<template>
  <FormGroup
    :error="error"
    :errorMessage="errorMessage"
  >
    <template v-slot="params">
      <r-input
        :label="label"
        :value="value"
        :error="error"
        @input="$emit('input', $event)"
      />
    </template>
    <template v-slot:after>
      <slot name="after"></slot>
    </template>
  </FormGroup>
</template>

<script>
  import FormGroup from "@/components/FormGroup.vue";

  export default {
    name: 'FormInput',
    components: {
      FormGroup,
    },
    props: {
      label: {
        type: String,
        default: null,
      },
      value: {
        type: [String, Number],
      },
      error: {
        type: Boolean,
        default: false, 
      },
      errorMessage: {
        type: String,
        default: ''
      }
    },
  }
</script>
